import { render, staticRenderFns } from "./EditarCupDialogComponent.vue?vue&type=template&id=4ca2d22c&scoped=true"
import script from "./EditarCupDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarCupDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarCupDialogComponent.vue?vue&type=style&index=0&id=4ca2d22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2d22c",
  null
  
)

export default component.exports